// Desktop top nav with sliding indicator — mirrors vanilla .nav + nav-slider.
// Visible only on screens ≥ 701px (mobile uses MobileNav instead).

import { useRef, useEffect } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { usePermissions } from '../hooks/usePermissions'

const TAB_LABELS: Record<string, string> = {
  overview: 'Overview',
  projects: 'Projects',
  estimates: 'Estimates',
  expenses: 'Expenses',
  payments: 'Payments',
  clients: 'Clients',
  subs: 'Subs',
  vendors: 'Vendors',
  bidroom: 'Bid Room',
  portfolio: 'Portfolio',
  reports: 'Reports',
  timelog: 'My Hours',
  options: 'Options',
}

function tabPath(key: string) {
  return key === 'overview' ? '/' : `/${key}`
}

export default function Nav() {
  const { tabs } = usePermissions()
  const sliderRef = useRef<HTMLDivElement>(null)
  const navRef = useRef<HTMLDivElement>(null)
  const navigate = useNavigate()

  function updateSlider() {
    if (!navRef.current || !sliderRef.current) return
    const active = navRef.current.querySelector('button.active') as HTMLElement | null
    if (!active) {
      sliderRef.current.style.width = '0'
      return
    }
    sliderRef.current.style.width  = `${active.offsetWidth}px`
    sliderRef.current.style.left   = `${active.offsetLeft}px`
  }

  useEffect(() => {
    // Update slider on mount + whenever active tab changes
    requestAnimationFrame(updateSlider)
  })

  return (
    <nav className="nav" ref={navRef} aria-label="Main navigation">
      <div className="nav-slider" ref={sliderRef} aria-hidden />
      {tabs.map((key) => (
        <NavLink key={key} to={tabPath(key)} end={key === 'overview'}>
          {({ isActive }) => (
            <button
              className={isActive ? 'active' : ''}
              onClick={() => navigate(tabPath(key))}
              aria-current={isActive ? 'page' : undefined}
            >
              {TAB_LABELS[key] ?? key}
            </button>
          )}
        </NavLink>
      ))}
    </nav>
  )
}
